import styled from "styled-components";
// import { Link as LinkS } from "react-scroll";
// import { HashLink as LinkH } from "react-router-hash-link";

export const H1 = styled.h1`
  font-family: Oswald;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color1};
  font-size: 2.5em;
  font-weight: bold;
  margin: 30px auto;
  border-bottom: 5px solid;
`;
